export const MODEL_DATA_STATUS = {
    NOT_READY: Symbol('not_ready'),
    FROM_CACHE: Symbol('from_cache'), // we need a better name, intermediate state
    COMPLETE: Symbol('complete')
};

export class BaseModel extends EventTarget {

    setCacheLifecycle() {
        // if no lifecycle timeout defined, then do not go back from complete to previous status, information does not go back to stale
        if (!this._lifecycleTimeout && this._status != MODEL_DATA_STATUS.COMPLETE) {
            this._status = MODEL_DATA_STATUS.FROM_CACHE;
            return;
        }

        const minutesSinceLastFetch = (Date.now() - this._lastFetchedTs) / 60000;
        const dataIsStale = minutesSinceLastFetch > this._lifecycleTimeout;
        if (dataIsStale || (!dataIsStale && this._status == MODEL_DATA_STATUS.NOT_READY)) {
            // if we are within lifecycle time, then data is not stale, move status forward if still on initial one
            // if lifecycle time has been exceeded then set status anyway
            this._status = MODEL_DATA_STATUS.FROM_CACHE;
        }
    }

    setCompleteLifecycle() {
        this._lastFetchedTs = Date.now();
        this._status = MODEL_DATA_STATUS.COMPLETE;
    }

    // how long in minutes until data from cache becomes stale
    setLifecycleTimeout(minutes: number) {
        this._lifecycleTimeout = minutes;
    }

    get status() {
        if (this._lifecycleTimeout && this._lastFetchedTs) {
            const minutesSinceLastFetch = (Date.now() - this._lastFetchedTs) / 60000;
            if (minutesSinceLastFetch > this._lifecycleTimeout) {
                this._status = MODEL_DATA_STATUS.FROM_CACHE;
            }
        }

        return this._status;
    }

    get hasLifecycleStarted() {
        return this._status === MODEL_DATA_STATUS.FROM_CACHE || this._status === MODEL_DATA_STATUS.COMPLETE;
    }

    protected _status: symbol = MODEL_DATA_STATUS.NOT_READY;
    protected _lastFetchedTs: number = 0;
    protected _lifecycleTimeout: number = 0;
}